<div class="card">
    <div class="card-header">
        <div class="row bg-light py-2">
            <div class="col-6 d-flex align-items-center">
              <div class="row">
                <div class="col-4 mt-4 fs-4">
                  <i class="fa-solid fa-calendar-days me-2"></i>Rostering
                </div>
                <div class="col-4">
                  <label for="from_date" class="pb-2">{{
                    "From Date" | translate
                  }}</label>
                           <input
                           type="date"
                           id="from_date"
                           class="form-control"
                           [ngModel]="startDate | date:'yyyy-MM-dd'"
                           (change)="onStartDateChanged($event.target.value)"
                           style="width: 27vh;"
                       />  
                </div>
                <div class="col-4">
                  <label for="to_date" class="pb-2">{{
                    "To Date" | translate
                  }}</label>
                  
                  <input
                  type="date"
                  id="to_date"
                  class="form-control"
                  [ngModel]="endDate | date:'yyyy-MM-dd'"
                  (ngModelChange)="onEndDateChanged($event)"
                  style="width: 27vh;"
              />
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-6">
                  <label for="teams" class="pb-2">{{
                    "Select Team" | translate
                  }}</label>
                  <select class="form-select taskspanel" id="teams" #selectedTeam>
                    <option value="0">Select</option>
                    <option *ngFor="let c of teamList">{{ c.teamName }}</option>
                  </select>
                </div>
                <div class="col-6  mt-4" style="padding-top: 7px;">
                  <button class="btn btn-primary me-2">Roster</button>
                  <button class="btn btn-success">Save</button>
                </div>
              </div>
            </div>
          </div>
      </div>
  
        <div class="card-body ">
            <div class="bg-light d-flex align-items-center p-2">
                <div class="d-flex align-items-center justify-content-between w-100">
                    <span style="font-size: 14px; margin-top: 7px; font-weight: 600;">Select All Employees</span>
              <form [formGroup]="form">
                <div class="input-group searchvehicles bg-white">
                  
                  <input
                  (keyup)="page =1"
                  formControlName="searchValue"
                  name="searchValue"
                    type="text"
                    class="form-control reportsbox"
                    placeholder="{{'Search'|translate}}"
                    autocomplete="off"
                    style="width: 25vh;"
                  />
                
                  <div class="input-group-append">
                    <button
                      class="btn"
                      type="button"
                      style="padding: 1vh 1.4vh 1.1vh 1.4vh"
                    >
                      <img
               
                        src="/assets/icons/searchicon.png"
                        alt="search"
                        style="width: 2.3vh"
                      />
                    </button>
                  </div>
                </div>
              </form>
                </div>         
            </div>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="table_head_text">Employee ID</th>
                        <th class="table_head_text">Name</th>
                        <ng-container *ngFor="let date of dateRange">
                            <th class="text-nowrap table_head_text">{{ date | dateFormat: 'dd-MM-yyyy' }}</th>
                        </ng-container>

                    </tr>
                </thead>
                <tbody *ngIf="empList.length">
                    <tr *ngFor="let emp of empList  | searchPipe : form.value.searchValue |  paginate : {
                         itemsPerPage: pageOption,
                          currentPage: page,
                         totalItems: (empList  | searchPipe : form.value.searchValue).length
                          };let i=index">
                        <td>{{ emp.empId }}</td>
                        <td>{{ emp.name }}</td>
                        <ng-container *ngFor="let date of dateRange; let i = index">
                          <td (click)="showPopup(i, $event)"><!-- Your action buttons or content here --></td>
                        </ng-container>
                      </tr>
                
                </tbody>
                <tbody *ngIf="!empList.length">
                    <tr>
                        <td colspan="7">
                            <div class="d-flex justify-content-center align-items-center" style="height: 48vh">
                                <img src="/assets/images/datanotfound.png" alt="NO DATA AVAILABLE IN TABLE" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- <div *ngIf="showOptions1" class="popup">
      <ul class="showOptions py-2">
        <li (click)="setLoginLogoutTime()" class="py-1">Set Login/LogOut Time</li>
        <li (click)="setAsWeekend()" class="py-1">Set as Weekend</li>
        <li (click)="setAsOnLeave()" class="py-1">Set as Onleave</li>
        <li (click)="raiseAdhoc()" class="py-1">Raise Adhoc</li>
        <li (click)="removeRoster()" class="py-1">Remove Roster</li>
        <li (click)="copyPreviousRoster()" class="py-1">Copy previous roster</li>
    </ul>   
        <button class="btn btn-danger" (click)="hideOptions()">Close</button>
    </div> -->
    <div *ngIf="showOptions1" class="popup" [style.top.px]="popupTop" [style.left.px]="popupLeft" (click)="onPopupClick($event)">
      <ul class="showOptions py-2">
        <li (click)="setLoginLogoutTime()" class="py-1">Set Login/LogOut Time</li>
        <li (click)="setAsWeekend()" class="py-1">Set as Weekend</li>
        <li (click)="setAsOnLeave()" class="py-1">Set as Onleave</li>
        <li (click)="raiseAdhoc()" class="py-1">Raise Adhoc</li>
        <li (click)="removeRoster()" class="py-1">Remove Roster</li>
        <li (click)="copyPreviousRoster()" class="py-1">Copy previous roster</li>
      </ul>   
    </div>
